<template>
  <div>
    <router-view :key="$route.fullPath"></router-view>
    <contact-us-backdrop></contact-us-backdrop>
    <contact-us></contact-us>
  </div>
</template>

<script>
import ContactUs from '@/components/ContactUs.vue';
import ContactUsBackdrop from '@/components/ContactUsBackdrop.vue';
export default {
  name: 'App',
  components: {
    ContactUs,
    ContactUsBackdrop
  },
  created() {},
  watch: {
    // Update the pipedrive visitor tracker on each page change
    $route() {
      if (window && window.ldfdr && window.ldfdr.pageview) {
        window.ldfdr.pageview();
      }
    }
  }
};
</script>

<style lang="scss">
//
// Note:
// - _includes.scss is imported globally by webpack
// - This is so every component in the app has access
//    to common SCSS variables, mixins etc
// - See vue.config.js ion propject root
//
@import '@/styles/main.scss';
</style>
